<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentcolor">
    <path
      d="M22 11h-2V5.78C20 4.25 18.65 3 17 3H7C5.35 3 4 4.25 4 5.78V11H2v2h2v5.18c0 1.53 1.35 2.78 3 2.78h10c1.65 0 3-1.25 3-2.78V13h2v-2Zm-4 7.18c0 .42-.46.78-1 .78H7c-.54 0-1-.36-1-.78V5.78C6 5.36 6.46 5 7 5h10c.54 0 1 .36 1 .78v12.4Z"
    />
    <path d="m10.13 17.46.57-4.01H7.83L12.99 6h1.15l-.57 4.59h3.44l-5.73 6.88h-1.15v-.01Z" />
  </svg>
</template>

<script>
export default {};
</script>
